<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'create_relative_connection' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="checkBeforeClose()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" style="text-align: center; font-size: 14px">
    @if (countType === 'one') {
      <div class="con_msg">{{userName}}{{'connected_msg_1' | translate}}{{userType?.name}}
      {{'connected_msg_2' | translate}}{{userName}}{{'connected_msg_2_1' | translate}}</div>
      <mat-form-field style="margin-top: 15px">
        <mat-select placeholder="{{'choice' | translate}}" [(ngModel)]="chosenType">
          @for (gt of genderTypes; track gt) {
            <mat-option [value]="gt">
              {{gt.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (countType === 'many') {
      <div class="con_msg">{{'connected_msg_3' | translate}}{{userName}}</div>
      <div class="con_msg">{{'connected_msg_4' | translate}}</div>
      @for (user of users; track user) {
        <div class="user-row">
          <div class="ur-name">{{user.firstName + ' ' + user.lastName}}</div>
          <div class="ur-type">
            <mat-form-field style="margin-top: 15px">
              <mat-select placeholder="{{'choice' | translate}}" (valueChange)="changeType($event, user.id)"
                [value]="user.genderTypeId">
                <mat-option [value]="0">-</mat-option>
                @for (gt of genderTypes; track gt) {
                  <mat-option [value]="gt.id">
                    {{gt.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
    }

  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign=" center">

    <button mat-raised-button
      (click)="checkBeforeClose()"
      class="save-button mat-accent"
      aria-label="SAVE">
      {{'main.cancel' | translate}}
    </button>

    <button  mat-raised-button
      (click)="saveConnection()"
      class="save-button mat-accent"
      [disabled]="!chosenType && countType === 'one'"
      aria-label="SAVE" >
      {{'main.save' | translate}}
    </button>


  </div>
</div>
